import { HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest } from '../api/HealthSystemApi';
import { DayOfWeek } from './common';
import { AnimalTrendDataType } from './animal';
import { RelativeDateWindow } from '../utils/date-range';

export enum ReportFrequency {
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

export const ReportFrequencyTranslations: Record<ReportFrequency, string> = {
  [ReportFrequency.Weekly]: 'f-report-frequency-weekly',
  [ReportFrequency.Monthly]: 'f-report-frequency-monthly'
};

export interface ReportSourceViewModel {
  savedSearchId: string;
  name: string;
  query: HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest;
}

export interface ScheduledReportViewModel {
  id: string;
  farmId: string;
  name: string;
  animalTrendDataType: AnimalTrendDataType;
  relativeDateWindow: RelativeDateWindow;
  frequency: ReportFrequency;
  dayOfWeek: DayOfWeek;
  recipients: string[];
  sources: ReportSourceViewModel[];
  isActive: boolean;
  createdAt: string;
  lastSentAt: string | null;
  nextSendAt: string | null;
}

export interface CreateScheduledReportInput {
  name?: string | null;
  animalTrendDataType: AnimalTrendDataType;
  relativeDateWindow: RelativeDateWindow;
  frequency: ReportFrequency;
  dayOfWeek: DayOfWeek;
  recipients: string[];
  sourceIds: string[];
}

export type UpdateScheduledReportInput = CreateScheduledReportInput;
